import { WebClientService } from '../services/webclient';
export class StatusController {
    log;
    userConfig;
    state = "error";
    unreadCount = 0;
    expandStatusBar = false;
    expandStatusBarTimer = null;
    expandStatusBarTimeout = 3000;
    reconnectTimeout;
    $timeout;
    $state;
    controllerService;
    stateService;
    timeoutService;
    webClientService;
    static $inject = [
        '$scope', '$timeout', '$state',
        'ControllerService', 'StateService', 'LogService', 'TimeoutService', 'WebClientService',
    ];
    constructor($scope, $timeout, $state, controllerService, stateService, logService, timeoutService, webClientService) {
        this.log = logService.getLogger('Status-C', 'color: #000; background-color: #ffff99');
        this.userConfig = window['UserConfig'];
        this.$timeout = $timeout;
        this.$state = $state;
        this.controllerService = controllerService;
        this.stateService = stateService;
        this.timeoutService = timeoutService;
        this.webClientService = webClientService;
        this.stateService.evtGlobalConnectionStateChange.attach((stateChange) => {
            $scope.$apply(() => {
                this.onStateChange(stateChange.state, stateChange.prevState);
            });
        });
        this.stateService.evtUnreadCountChange.attach((count) => {
            this.unreadCount = count;
        });
    }
    get statusClass() {
        const classes = [
            `status-task-${this.webClientService.chosenTask}`,
            `status-${this.state}`,
        ];
        if (this.webClientService.hasAppleNonVoipPushToken()) {
            classes.push(`apns-non-voip`);
        }
        if (this.userConfig.VISUALIZE_STATE) {
            classes.push(`visualize-state`);
        }
        return classes.join(' ');
    }
    onStateChange(newValue, oldValue) {
        this.log.debug('State change:', oldValue, '->', newValue);
        if (newValue === oldValue) {
            return;
        }
        this.state = newValue;
        const isWebrtc = this.webClientService.chosenTask === "webrtc";
        const isRelayedData = this.webClientService.chosenTask === "relayed-data";
        switch (newValue) {
            case 'ok':
                this.collapseStatusBar();
                break;
            case 'warning':
                if (oldValue === 'ok' && isWebrtc) {
                    this.scheduleStatusBar();
                }
                this.webClientService.clearIsTypingFlags();
                if (isRelayedData && oldValue !== 'error') {
                    this.reconnectIos();
                }
                break;
            case 'error':
                if (isWebrtc) {
                    this.reconnectAndroid();
                }
                if (isRelayedData && this.stateService.attempt === 0) {
                    this.reconnectIos();
                }
                break;
            default:
                this.log.error('Invalid state change: From', oldValue, 'to', newValue);
        }
    }
    scheduleStatusBar() {
        this.expandStatusBarTimer = this.timeoutService.register(() => {
            this.expandStatusBar = true;
        }, this.expandStatusBarTimeout, true, 'expandStatusBar');
    }
    collapseStatusBar() {
        this.expandStatusBar = false;
        if (this.expandStatusBarTimer !== null) {
            this.timeoutService.cancel(this.expandStatusBarTimer);
        }
    }
    reconnectAndroid() {
        this.log.info(`Connection lost (Android). Reconnect attempt #${this.stateService.attempt + 1}`);
        if (this.$state.includes('messenger')) {
            this.scheduleStatusBar();
        }
        const originalKeyStore = this.webClientService.salty.keyStore;
        const originalPeerPermanentKeyBytes = this.webClientService.salty.peerPermanentKeyBytes;
        this.webClientService.stop({
            reason: "stop",
            send: true,
            close: false,
        });
        this.webClientService.init({
            keyStore: originalKeyStore,
            peerTrustedKey: originalPeerPermanentKeyBytes,
            resume: true,
        });
        const pause = this.stateService.attempt >= WebClientService.MAX_CONNECT_ATTEMPTS;
        if (pause) {
            this.webClientService.showDeviceUnreachableDialog();
        }
        this.webClientService.start(pause)
            .then(() => { }, (error) => {
            this.log.error('Error state:', error);
        }, (progress) => {
            this.log.debug('Connection buildup advanced:', progress);
        })
            .finally(() => {
            this.collapseStatusBar();
        });
        ++this.stateService.attempt;
    }
    reconnectIos() {
        this.log.info(`Connection lost (iOS). Reconnect attempt #${++this.stateService.attempt}`);
        const originalKeyStore = this.webClientService.salty.keyStore;
        const originalPeerPermanentKeyBytes = this.webClientService.salty.peerPermanentKeyBytes;
        const startTimeout = 500;
        this.log.debug('Stopping old connection');
        this.webClientService.stop({
            reason: "stop",
            send: true,
            close: false,
            connectionBuildupState: 'push',
        });
        const push = (() => {
            if (this.$state.includes('welcome')) {
                return {
                    send: true,
                    reason: 'still on welcome page',
                };
            }
            const pendingWireMessages = this.webClientService.unacknowledgedWireMessages;
            if (pendingWireMessages > 0) {
                return {
                    send: true,
                    reason: `${pendingWireMessages} unacknowledged wire messages`,
                };
            }
            return {
                send: false,
            };
        })();
        this.$timeout.cancel(this.reconnectTimeout);
        this.reconnectTimeout = this.$timeout(() => {
            if (push.send) {
                this.log.debug(`Starting new connection with push, reason: ${push.reason}`);
            }
            else {
                this.log.debug('Starting new connection without push');
            }
            this.webClientService.init({
                keyStore: originalKeyStore,
                peerTrustedKey: originalPeerPermanentKeyBytes,
                resume: true,
            });
            this.webClientService.start(!push.send).then(() => { }, (error) => {
                this.log.error('Error state:', error);
            }, (progress) => {
                this.log.debug('Connection buildup advanced:', progress);
            });
        }, startTimeout);
        if (this.webClientService.hasAppleNonVoipPushToken()) {
            this.webClientService.showDeviceUnreachableDialog();
        }
    }
    showMessenger() {
        return this.controllerService.getControllerName() !== undefined
            && this.controllerService.getControllerName() === 'messenger';
    }
    get faviconFilename() {
        switch (this.state) {
            case "ok":
                if (this.unreadCount > 0) {
                    return 'favicon-32x32-unread.png';
                }
                else {
                    return 'favicon-32x32.png';
                }
                break;
            case "warning":
                const isRelayedData = this.webClientService.chosenTask === "relayed-data";
                if (isRelayedData && !this.webClientService.hasAppleNonVoipPushToken()) {
                    return 'favicon-32x32.png';
                }
                else {
                    return 'favicon-32x32-warning.png';
                }
                break;
            case "error":
                return 'favicon-32x32-error.png';
                break;
        }
    }
}
